import { Button } from "primereact/button";

import { buttonSendEmail, formResetPassword } from "../../_constants";

export const SendEmailResetPasswordBtn = () => {
  return (
    <div className="flex-container justify-end">
      <Button
        label={buttonSendEmail}
        type="submit"
        form={formResetPassword}
        className="container-button"
      ></Button>
    </div>
  );
};
